module.exports = __webpack_public_path__ + "static/media/sl.f6315f74.svg";